module.exports = __webpack_public_path__ + "static/outside-the-wire-4399a6ea0150543c7050213efeeb2f44.jpg";